import { atomWithStorage, createJSONStorage } from 'jotai/utils';

const sessionStorageBackend = createJSONStorage<boolean>(() => sessionStorage);

export const pwaInstallDismissedAtom = atomWithStorage<boolean>(
  'prospero_pwa_dismissed',
  false,
  sessionStorageBackend,
);
